import Image from 'components/Image'
import Title from 'components/Title'
import Paragraph from 'components/Paragraph'

import Styled from './styled'

export default function CardPromotion({ image, name, detail, expireDate }) {
  return (
    <Styled>
      <Image src={image} imgixWidth={150} height={150} className="image-promotion" />

      <div className="info-block">
        <Title level={3} className="card-title" ellipsis={{ rows: 2 }}>
          {name}
        </Title>
        <Paragraph className="detail" ellipsis={{ rows: 2 }}>
          {detail}
        </Paragraph>
        <Paragraph small className="date">
          {expireDate}
        </Paragraph>
      </div>
    </Styled>
  )
}
